import { AfterViewChecked, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewChecked {
  previousUrl: any = null;
  currentUrl: any = null;
  constructor(router: Router) {
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;

      });
  }
  ngAfterViewChecked(): void {
    let prev = this.previousUrl?.split("/");
    let path = prev ? prev[prev.length - 1] : '';

    let bread = document.querySelector<HTMLElement>('cx-breadcrumb');

    if (path === 'login' && path !== 'contact') {
      let test = document.querySelector<HTMLElement>('.contact');
      test?.setAttribute('style', "display:none");
    } else {
      let test2 = document.querySelector<HTMLElement>('.register');
      test2?.setAttribute('style', "display:none");
    }

  }
  title = 'ekaterrastore';
}
